import type { Entity } from "common/entities/types";
import { hasRolePermissionTo } from "common/functions/roles";
import { filterFormsByEntity } from "common/functions/forms";
import type { Context } from "common/types/context";

export const shouldIncludeSwitchForm = (context: Context, entity: Entity) =>
  hasRolePermissionTo(context.role, entity.name, "SwitchForm") &&
  filterFormsByEntity(context.forms, entity.name).length > 0;
